import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Button from "../../../shared/components/Button/Button";
import Backicon from "../../../shared/components/Backicon/Backicon";
import doctorstyles from "./doctorregister.module.css";

import Appointments from "../Appointments/Appointments";
import HealthReport from "../HealthReports/HealthReports";
import DoctorProfile from "../DoctorProfileHome/DoctorProfile";
import EmergencyPatients from "../EmergencyPatients/EmergencyPatients";

const initialState = {
  Name: "",
  Email: "",
  Address: "",
  Password: "",
  NameError: "",
  EmailError: "",
  AddressError: "",
  PasswordError: "",
  isLogin: true,
};
class DoctorRegister extends Component {
  state = initialState;

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let EmailError = "";
    let AddressError = "";
    let PasswordError = "";
    //Name Error
    if (!this.state.Name) {
      NameError = "Invalid Name";
    }

    //Email Error
    if (!this.state.Email.includes("@")) {
      EmailError = "Invalid Email";
    }
    //Address Error
    if (!this.state.Address) {
      AddressError = "Address Cannot Be Empty";
    }
    // Password Error
    if (this.state.Password.length < 8) {
      PasswordError = "Need a strong Password";
    }

    if (EmailError || NameError || AddressError || PasswordError) {
      this.setState({ EmailError, NameError, AddressError, PasswordError });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);
      const doctor_register = {
        Name: this.state.Name,
        Email: this.state.Email,
        Address: this.state.Address,
        Password: this.state.Password,
      };
      localStorage.setItem(
        "doctor_login_signup",
        JSON.stringify(doctor_register)
      );
      //clear form
      this.setState(initialState);
    }
    this.props.history.push("/doctor/doctor-profile");
  };

  render() {
    return (
      <>
        <div className={doctorstyles.content}>
          <div className={doctorstyles.pregbanner}>
            <Backicon
              onClick={() => this.props.history.goBack()}
              style={{
                background:
                  "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                color: "white",
              }}
            />
            <h1>
              doctor <br /> register
            </h1>
          </div>
          <div className={doctorstyles.signInStyles}>
            <div>
              <div className={doctorstyles.regbuttons}>
                <button onClick={() => this.setState({ isLogin: true })}>
                  Login
                </button>
                <button onClick={() => this.setState({ isLogin: false })}>
                  Sign Up{" "}
                </button>
              </div>
              <form className={doctorstyles.signupbtn}>
                {!this.state.isLogin && (
                  <>
                    <input
                      name="Name"
                      placeholder={"Name"}
                      value={this.state.name}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.NameError ? (
                      <div className={doctorstyles.error}>
                        {this.state.NameError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Email"
                  placeholder="Email"
                  value={this.state.Email}
                  onChange={(e) => this.change(e)}
                />
                {this.state.EmailError ? (
                  <div className={doctorstyles.error}>
                    {this.state.EmailError}
                  </div>
                ) : null}
                <br />

                {!this.state.isLogin && (
                  <>
                    <textarea
                      name="Address"
                      placeholder="Address"
                      value={this.state.Address}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.AddressError ? (
                      <div className={doctorstyles.error}>
                        {this.state.AddressError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Password"
                  type="password"
                  placeholder="Password"
                  value={this.state.Password}
                  onChange={(e) => this.change(e)}
                />
                {this.state.PasswordError ? (
                  <div className={doctorstyles.error}>
                    {this.state.PasswordError}
                  </div>
                ) : null}
                <div className={doctorstyles.submitButton}>
                  <Button
                    onClick={(e) => this.onSubmit(e)}
                    buttonName={this.state.isLogin ? "Log in" : "sign up"}
                    style={{
                      color: "white",
                      width: "260px",
                      margin: "20px 30px",
                    }}
                  ></Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function DoctorRoutes() {
  return (
    <Switch>
      <Route path="/doctor" exact component={DoctorRegister} />
      <Route path="/doctor/doctor-profile" exact component={DoctorProfile} />
      <Route path="/doctor/appointments" component={Appointments} />
      <Route path="/doctor/health-reports" component={HealthReport} />
      <Route path="/doctor/emergencypatients" component={EmergencyPatients} />
    </Switch>
  );
}

export default DoctorRoutes;
